import React, { useEffect, useState } from 'react';
import { Alert, Modal, Box, ButtonGroup, Button, MenuItem, Paper, Stack, TextField, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import EditIcon from '@mui/icons-material/Edit';
import Styles from '../../../common/styles/styles';
import {validateNotNull} from '../../../common/utils/validationUtil';

export default function SlaAlertsModal({ slaAlert, onTriggerCreate, onTriggerUpdate }) {
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});  
  const [title, setTitle] = useState('');

  const isFormValid = Object.values(errors).filter(value => value !=='').length > 0;

  const handleOpen = () => {
    setOpen(true);
    setTitle('Create SlaAlert');
  }

  const handleEditOpen = () => {
    setOpen(true);
    setTitle('Update SlaAlert');
  }

  const handleClose = () => setOpen(false);

  const handleUpdate = async (event) => {
      await createSlaAlert(event);
      setOpen(false);
      if (formData.id === '') {
          onTriggerCreate(formData);
      } else {
          onTriggerUpdate(formData);
      }
  }

  const [formData, setFormData] = useState({
        id: '',
        name: '',
        description: '',
        active: ''
  })

  const handleInputChange = (field) => (event) => {
      const value = event.target.value;
      setFormData({ ...formData, [field]: value });
    
      const newErrors = { ...errors };

      newErrors[field] = validateNotNull(field, value);
      setErrors(newErrors);
  }
  
  const options = [
    { value: true, label: 'True' },
    { value: false, label: 'False' }
  ]
  
  const createSlaAlert = async (event) => {

    try {
        event.preventDefault();
        if (formData.id === '') {
            const response = await fetch(`${process.env.REACT_APP_API}/slaAlerts`, {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            if (result.message !== 'success') {
                toast.error(result.message);
            }
        } else {
          const response = await fetch(`${process.env.REACT_APP_API}/slaAlerts/${formData.id}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(formData),
          });

          const result = await response.json();
          if (result.message !== 'success') {
            toast.error(result.message);
          }

        }
    } catch (error) {
      console.error('Network error.  Please try again: ', error);
    }
  }
  
  const textFieldStyles = Styles.textFieldStyles;

  useEffect(() => {
    if (slaAlert.id !== undefined) {
      setFormData(slaAlert);
    } 
  }, [slaAlert]);

  return (
    <>
        { formData.id === "" && 
            <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleOpen}>
                Add New
            </Button>
        }

        { formData.id !== '' && 
          <Button variant="outlined" color="success" size="small" onClick={handleEditOpen}>
              <EditIcon />
          </Button>
        }
        
        <Modal 
          open={open} 
          onClose={handleClose}
          style={{
            overlay: {
              backgroundColor: '#080030', 
            },
            content: {
              backgroundColor: '#080030',
            },
          }}
        >
            <Box sx={{color: 'white', p: 4}}>
                <Box
                  component={Paper}
                  elevation={3}
                  sx={{
                    mx: 'auto',
                    width: 400,
                    bgcolor: '#1e1e1e',
                    p: 2,
                  }}
                >
                  {errors.submit && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                      {errors.submit}
                    </Alert>
                  )}
                  <Typography variant="h4" component="h2" color="white" mb={2}>
                    {title}
                  </Typography>

                  <Box component="form" onSubmit={handleUpdate}>
                    <Stack spacing={2}>
                        <TextField
                            fullWidth
                            required
                            label="Name"
                            value={formData.name}
                            onChange={handleInputChange('name')}
                            error={!!errors.name}
                            helperText={errors.name}
                            sx={ textFieldStyles }
                        />
                        <TextField
                            fullWidth
                            required
                            label="Description"
                            value={formData.description}
                            onChange={handleInputChange('description')}
                            error={!!errors.description}
                            helperText={errors.description}
                            sx={ textFieldStyles }                        
                        />
                        <TextField
                            select
                            required
                            fullWidth
                            label="Active"
                            value={formData.active}
                            onChange={handleInputChange('active')}
                            error={!!errors.active}
                            helperText={errors.active}
                            sx={ textFieldStyles }
                        >
                            {options.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </TextField>
                  <ButtonGroup 
                    size="small"
                    variant="contained" 
                    aria-label="Basic button group" 
                    fullWidth
                    sx={{ mt:2 }}
                  >
                    <Button
                      onClick={handleClose}
                      type="cancel"
                      variant="contained"
                      sx={ Styles.buttonStyle }
                    >
                      Cancel
                    </Button>              
                    <Button
                      type="submit"                      
                      variant="contained"
                      sx={{ ...Styles.buttonStyle,  ml:4 }}
                      disabled={isFormValid}
                    >
                      {title}
                    </Button>
                  </ButtonGroup>
          </Stack>
        </Box>
    </Box>

</Box>
</Modal>            
    </>
  );
}